import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-665a1472"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-group-item__inner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "price-group-item__title" }
const _hoisted_4 = { class: "price-group-item__description" }
const _hoisted_5 = { class: "price-group-item__price sdfsdf" }
const _hoisted_6 = {
  key: 0,
  class: "price-group-item__number-spinner-wrapper"
}
const _hoisted_7 = {
  key: 1,
  class: "price-group-item__not-available"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberSpinner = _resolveComponent("NumberSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["price-group-item", !_ctx.isAvailable ? 'price-group-item--is-disabled' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "price-group-item__img img-fluid",
        src: '/static/img/price-groups/' + _ctx.imgName
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.description), 1),
      _createElementVNode("div", _hoisted_5, " CHF " + _toDisplayString(_ctx.price.toFixed(2)), 1)
    ]),
    (_ctx.isAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(), _createBlock(_component_NumberSpinner, {
            max: _ctx.maxCounter,
            min: _ctx.minCounter,
            value: _ctx.counter,
            onChangeValue: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('changeCounter', $event))),
            key: _ctx.id,
            inputName: 'count-'+_ctx.id,
            inputId: 'count-'+_ctx.id
          }, null, 8, ["max", "min", "value", "inputName", "inputId"]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.translate('shop.ticket.configuration.not-available')), 1))
  ], 2))
}